"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _KYCLevel = _interopRequireDefault(require("../KYC/KYCLevel"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYC_AGLevelsComponent = function KYC_AGLevelsComponent(props) {
  var highlightStyle = props.highlightStyle,
    levels = props.levels,
    openKYCSidePane = props.openKYCSidePane,
    verificationLevel = props.verificationLevel;
  var isDisabled = false;
  var cannotIncrease = false;
  return levels.map(function (level) {
    if (level.level === 0) {
      return /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], {
        key: level.level,
        verified: true,
        config: level,
        highlightStyle: highlightStyle
      });
    }
    if (cannotIncrease) {
      isDisabled = true;
    }
    if (verificationLevel < level.level) {
      cannotIncrease = true;
    }
    return /*#__PURE__*/_react["default"].createElement(_KYCLevel["default"], {
      key: level.level,
      config: level,
      openPane: function openPane() {
        return openKYCSidePane(level);
      },
      highlightStyle: highlightStyle,
      verified: verificationLevel >= level.level,
      currentLevel: verificationLevel >= level.level - 1,
      canIncrease: cannotIncrease && !isDisabled
    });
  });
};
var _default = exports["default"] = KYC_AGLevelsComponent;